export default __webpack_public_path__ + "static/media/DSC_0531.23763ffe.jpg";